import type { IMenuData } from "@/components/TabBar/index.d";
import { NO_MENUS_URLS } from "@/constants";
import { getMenus } from "@/service/account";
import { useRequest } from "ahooks";
import { useEffect, useMemo } from "react";
import { useHistory, matchPath } from "react-router-dom";

interface IOptions {
  source?: string;
  onSuccess?: () => void;
}

function isUrlInList(url: string, list: string[]) {
  return list.some((path) =>
    matchPath(url, {
      path: path,
      exact: true,
      strict: false,
    })
  );
}

export default function useTabMenus(options?: IOptions) {
  const { source, onSuccess } = options ?? {};
  const history = useHistory();

  const hasMenuBar = useMemo(() => {
    if (source && source !== "app") {
      return false;
    }
    if (isUrlInList(history.location.pathname.toLowerCase(), NO_MENUS_URLS)) {
      return false;
    }
    return true;
  }, [history.location.pathname, source]);

  const { data, run: fetchMenus } = useRequest<IMenuData>(getMenus, {
    manual: true,
    onSuccess,
  });

  useEffect(() => {
    if (hasMenuBar) {
      fetchMenus();
    }
  }, [fetchMenus, hasMenuBar]);

  return {
    menus: data?.data?.menu,
    hasMenuBar,
  };
}
